var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrURLInput',{attrs:{"value":_vm.modelValue,"disabled":_vm.disabled,"required":!_vm.disabled,"secure-url":true,"label":"Custom Impression Tracker"},on:{"input":_vm.onInputChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }